export default Object.freeze([
  {
    text: 'Физическое',
    value: '0',
  },
  {
    text: 'Психологическое',
    value: '1',
  },
  {
    text: 'Сексуальное',
    value: '2',
  },
  {
    text: 'Экономическое',
    value: '3',
  },
  {
    text: 'Пренебрежительное отношение',
    value: '4',
  },
  {
    text: 'Другое',
    value: '5',
  },
])
